import { createIcon } from '@chakra-ui/react';

export const Sms = createIcon({
  displayName: 'Sms',
  viewBox: '0 0 64 64',
  path: (
    <>
      <circle
        id="Ellipse_3"
        data-name="Ellipse 3"
        cx="32"
        cy="32"
        r="32"
        fill="green"
      />
      <g
        id="SMS_Bubble_-_S"
        data-name="SMS Bubble - S"
        transform="translate(14.379 19.171)"
      >
        <path
          id="SMS_Bubble_-_S-2"
          data-name="SMS Bubble - S"
          d="M24.556,2.11h-11.3A12.72,12.72,0,0,0,1.95,8.952,11.951,11.951,0,0,0,3.217,21.8a7.279,7.279,0,0,1-1.906,1.846A1.789,1.789,0,0,0,.542,25.36a1.731,1.731,0,0,0,1.238,1.457,9.23,9.23,0,0,0,2.977.486,7.875,7.875,0,0,0,1.505,0,9.437,9.437,0,0,0,3.345-1.1,12.886,12.886,0,0,0,3.846.583h11.1A12.479,12.479,0,0,0,37.232,14.512,12.479,12.479,0,0,0,24.556,2.24ZM10.475,17.945a4.473,4.473,0,0,1-3.01-1l.97-1a3.165,3.165,0,0,0,2.04.81c.8,0,1.271-.356,1.271-.842s0-.648-.936-.874l-1.2-.324c-1.371-.389-1.873-1.069-1.873-2.008a2.484,2.484,0,0,1,2.709-2.1,3.95,3.95,0,0,1,2.843,1.069l-1,.971a2.677,2.677,0,0,0-1.806-.842c-.736,0-1.137.324-1.137.777s.3.648.936.842l1.1.291c1.539.421,2.007,1.069,2.007,1.975A2.88,2.88,0,0,1,10.475,17.945Zm12.442,0H21.412V12.764L20.977,13.8l-1.505,3.594h-1.2L16.729,13.8l-.435-1.036v5.181h-1.4V10.788h2.04l1.639,3.918.334.842.334-.842,1.639-3.821h2.04Zm4.248,0a4.473,4.473,0,0,1-3.01-1l.97-1a3.4,3.4,0,0,0,2.04.81c.8,0,1.3-.356,1.3-.842s-.2-.648-.97-.874l-1.2-.324c-1.371-.389-1.873-1.069-1.873-2.008a2.484,2.484,0,0,1,2.709-2.1,3.95,3.95,0,0,1,2.843,1.069l-1,.971a2.609,2.609,0,0,0-1.806-.842c-.736,0-1.137.324-1.137.777s.3.648.936.842l1.1.291c1.539.421,2.007,1.069,2.007,1.975A2.851,2.851,0,0,1,27.165,17.945Z"
          transform="translate(-0.525 -2.11)"
          fill="#fff"
        />
      </g>
    </>
  ),
});
